import Choices from 'choices.js'
import {gsap} from 'gsap/gsap-core'
import ClickTrack from '../utils/click-track'

export class Form {
    constructor(el, fields) {
        console.log('Loaded Form')
        this.form = el
        this.fields = fields;
        this.button = el.querySelector('button.submit')


        this._setupEvents()
        this._select()
        this._privacy()
    }

    _setupEvents() {
        let formWrapper = document.querySelector('.form-data-lead__form')
        let error = document.querySelector('.form-data-lead__error')
        let thankYou = document.querySelector('.form-data-lead__thank-you')
        let form = this.form
        form.addEventListener('submit', (e) => {
            console.log('submit')
            e.preventDefault()
            this.button.setAttribute("disabled", "disabled")

            let isValid = true;
            this.fields.forEach((field) => {
                // console.log('validating ' + field)
                let input = this.form.querySelector(`[name=${field}]`)
                let valid = this._validate(input)
                // console.log(valid)
                isValid = isValid && valid
            })
            if (!isValid) {
                this.button.removeAttribute("disabled")
                return false;
            }

            // HACK PER PRODUZIONE, GENERA TOKEN MISMATCH
            let csrfToken = document.cookie
                .split('; ')
                .find(row => row.startsWith('XSRF-TOKEN='))
                .split('=')[1];
            console.log('found cookie token', csrfToken)
            form.querySelector('[name=_token]').value = csrfToken

            thankYou.classList.add('closed')
            error.classList.add('closed')
            form.querySelectorAll('.error-message').forEach((errorMessage) => {
                errorMessage.innerHTML = '';
            })
            form.querySelectorAll('.error').forEach((errorInput) => {
                errorInput.classList.remove('.error');
            })

            let xhr = new XMLHttpRequest()
            let formData = new FormData(form)
            xhr.addEventListener('error' , () => {
                this.button.removeAttribute("disabled")
                formWrapper.classList.add('closed')
                thankYou.classList.add('closed')
                error.classList.remove('closed')
            })

            xhr.addEventListener( 'load', (event) => {
                this.button.removeAttribute("disabled")

                let csrfToken = document.cookie
                    .split('; ')
                    .find(row => row.startsWith('XSRF-TOKEN='))
                    .split('=')[1];
                form.querySelector('[name=_token]').value = csrfToken

                switch (xhr.status) {
                    case 422:
                        let response = JSON.parse(xhr.response)
                        console.warn(response);
                        for (const [key, value] of Object.entries(response)) {
                            if (key === 'phone') {
                                // spam attack detected
                                error.style.display = 'block'
                                gsap.to(formWrapper, { opacity:0 })
                                gsap.to(thankYou, { opacity:0 })
                                gsap.to(error, { opacity:1 })
                                form.reset();
                            } else {
                                form.querySelector('[name=' + key + ']').classList.add('error')
                                form.querySelector('.error-message[data-name=' + key + ']').innerHTML = value
                            }
                        }
                        break;
                    case 200:
                        thankYou.style.display = 'block'
                        gsap.to(formWrapper, { opacity:0 })
                        gsap.to(thankYou, { opacity:1 })
                        gsap.to(error, { opacity:0 })
                        let roleText = form.querySelector('[name=role]').value
                        if (roleText !== '') {
                            form.querySelectorAll('select#role option').forEach((option) => {
                                if (option.value === roleText) {
                                    roleText = option.text
                                }
                            })
                        }
                        ClickTrack.track('form_subscription','form subscription', 'form sent', roleText)
                        form.reset();
                        break;
                    default:
                        this.button.removeAttribute("disabled")
                        error.style.display = 'block'
                        console.error(xhr.response)
                        gsap.to(formWrapper, { opacity:0 })
                        gsap.to(thankYou, { opacity:0 })
                        gsap.to(error, { opacity:1 })
                }

            });

            xhr.open(form.method, form.action)
            if (document.querySelector('body').dataset.env === 'stage') {
                xhr.setRequestHeader('Authorization', 'Basic ' + btoa('molteni:Ievievu1'));
            }
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
            xhr.send(formData)
        })
    }

    _select() {
        document.querySelectorAll('.form-data-lead__form select').forEach((element) => {
            new Choices(element, {

            })
        })
    }

    _privacy() {
        document.querySelectorAll('.form-data-lead__form .checkbox label a').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault()
                console.log(e.target.closest('.checkbox'))
                e.target.closest('.checkbox').parentNode.querySelector('.privacy_expl').classList.toggle('opened')

            })
        })
    }

    _setFieldStatus(field, message = '', isValid = true) {
        let container = field.closest('.form-input')
        if (!container) {
            container = field.closest('.checkbox')
        }
        let fieldError = container.querySelector('.error-message')
        // console.log(container, fieldError)
        if (isValid) {
            container.classList.remove('error')
            fieldError.innerText = ''
        } else {
            container.classList.add('error')
            fieldError.innerText = message
        }
    }

    _validate(field) {
        // console.log(field.dataset.validation, field.value)
        if (field.dataset.validation && field.dataset.validation.includes('required')) {
            if (field.type === 'checkbox' && !field.checked) {
                this._setFieldStatus(field, '', false)
                return false
            }
            if (field.value.trim() === "") {
                this._setFieldStatus(field, '', false)
                return false
            }
        }

        // check for a valid email address
        if (field.dataset.validation && field.dataset.validation.includes('email')) {
            const re = /\S+@\S+\.\S+/
            if (re.test(field.value)) {
                this._setFieldStatus(field)
            } else {
                this._setFieldStatus(field, '', false)
                return false
            }
        }

        this._setFieldStatus(field)
        return true
    }

    onResize() {
    }

}
